import { useDateFormatter, useTranslator } from '@bluebeam/react-i18n';
import classnames from 'classnames';
import Calendar from 'components/Icons/Calendar24';
import Profile from 'components/Icons/Profile';
import React, { ReactElement } from 'react';
import { RFI } from 'records/RFI';
import { RFIAnswer } from 'records/RFIAnswer';

interface Props {
  rfi: RFI;
  selectedRFI: RFI | null;
  onRFIClick: (clickRFI: RFI) => void;
}

const PostRFIListItem = (props: Props): ReactElement => {
  const { rfi, selectedRFI, onRFIClick } = props;
  const { translate } = useTranslator(['mapView', 'rfiPage']);
  const dateFormatter = useDateFormatter({
    dateStyle: 'long',
  });

  const answer = rfi.answer || new RFIAnswer();
  const isOpen =
    answer.answer === '' &&
    rfi.nextversionid === '' &&
    rfi.previousversionid !== '';

  const rfiDueDate: number = rfi?.answer?.respondingdate
    ? rfi?.answer?.respondingdate
    : rfi.duedate;

  const pastDueDate =
    answer === null && rfiDueDate !== 0 && rfiDueDate < Date.now() / 1000;

  return (
    <div
      className={classnames(
        'bgd-primary-blue-tint-90-h p3 bb-2 cursor-pointer',
        {
          'bgd-white-2': selectedRFI === null || selectedRFI.id !== rfi.id,
          'bgd-primary-blue-tint-90': selectedRFI && selectedRFI.id === rfi.id,
        }
      )}
      onClick={() => onRFIClick(rfi)}
    >
      <div className="row justify-between mb4">
        <div
          className={classnames('bgd-mid-grey-2 b-radius-3 px2 py1 bold', {
            'bgd-status-red': isOpen,
          })}
        >
          {translate('mapView:postRFIListItem.rfi')} {rfi.number}
          {rfi.versionnumber ? `.${rfi.versionnumber}` : null}
        </div>
        <div
          className="row items-center black-2"
          style={{
            color: pastDueDate ? 'var(--color-error)' : 'black-2',
          }}
        >
          <span className="mr1">
            <Calendar width="24px" />
          </span>
          {rfiDueDate !== 0
            ? dateFormatter.format(new Date(rfiDueDate * 1000))
            : translate('rfiPage:noDueDate')}
        </div>
      </div>
      <div className="medium font-size-6 mb2">{rfi.title}</div>
      <div className="row items-center black-2">
        <span className="mr2">
          <Profile width="16px" height="16px" />
        </span>
        <div>
          {answer.reviewingemail !== ''
            ? answer.reviewingemail
            : rfi.assigneeEmail}
        </div>
      </div>
    </div>
  );
};

export default PostRFIListItem;
